import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  TituloPaginaModule,
  WbaTableModule,
  SearchInputAnimationModule,
  WInputModule,
  BlocoNovaVisaoModule,
  WbaSelectModule,
  WbaButtonModule,
  WbaSelect2Module,
  WbaOptionModule,
  WbaOptGroupModule,
  ContadorModule,
  MegaMenuModule,
  ChipsFiltroModule,
  MenuRightFiltroModule,
  CardTituloTextoModule,
  BoxInformacoesModule,
  MsgSemDadosModule,
  MsgFixaPaginaModule,
} from '@wbatd/design-system-wba';

import { MoedaRealMaskPipe } from '../../pipes/moeda-real-mask-pipe';
import { CpfCnpjMaskPipe } from '../../pipes/cpf-cnpj-mask-pipe';
import { FiltroEmpresaCedenteSacadoComponent } from 'src/app/components/filtro-empresa-cedente-sacado/filtro-empresa-cedente-sacado.component';

//material
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FiltroEmpresaInvestidorComponent } from 'src/app/components/filtro-empresa-investidor/filtro-empresa-investidor.component';

@NgModule({
  declarations: [MoedaRealMaskPipe, CpfCnpjMaskPipe, FiltroEmpresaCedenteSacadoComponent, FiltroEmpresaInvestidorComponent],
  imports: [
    CommonModule,
    TituloPaginaModule,
    WbaTableModule,
    SearchInputAnimationModule,
    WInputModule,
    BlocoNovaVisaoModule,
    WbaSelectModule,
    WbaButtonModule,
    WbaSelect2Module,
    WbaOptionModule,
    WbaOptGroupModule,
    FormsModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatTabsModule,
    ContadorModule,
    MegaMenuModule,
    MatSelectModule,
    ChipsFiltroModule,
    MenuRightFiltroModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatSnackBarModule,
    CardTituloTextoModule,
    MatStepperModule,
    BoxInformacoesModule,
    MsgSemDadosModule,
    MsgFixaPaginaModule,
    MatTooltipModule,
  ],
  exports: [
    FontAwesomeModule,
    TituloPaginaModule,
    WbaTableModule,
    SearchInputAnimationModule,
    WInputModule,
    BlocoNovaVisaoModule,
    WbaSelectModule,
    WbaButtonModule,
    WbaSelect2Module,
    WbaOptionModule,
    WbaOptGroupModule,
    FormsModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatTabsModule,
    ContadorModule,
    MegaMenuModule,
    MoedaRealMaskPipe,
    CpfCnpjMaskPipe,
    MatSelectModule,
    ChipsFiltroModule,
    MenuRightFiltroModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatSnackBarModule,
    CardTituloTextoModule,
    MatStepperModule,
    BoxInformacoesModule,
    MsgSemDadosModule,
    MsgFixaPaginaModule,
    MatTooltipModule,
    FiltroEmpresaCedenteSacadoComponent,
    FiltroEmpresaInvestidorComponent,
  ],
})
export class SharedModule {}
